import Api from './Api';
import Configuracao from '../util/Configuracao';

class ExtratoApi extends Api {
  async consultarExtratoResumido (codServidor) {
    try {
      const extratoUrl = Configuracao.getConfiguracao().urlExtratoResumidoConsultar + codServidor;
      const response = await this.fetch(extratoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarBeneficiarioExtrato (filter) {
    try {
      const extratoUrl = Configuracao.getConfiguracao().urlExtratoBeneficiarioConsultar + filter.codServidor + '/' + filter.ano + '/' + filter.mes;
      const response = await this.fetch(extratoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarPrestadorExtrato (filter) {
    try {
      const extratoUrl = Configuracao.getConfiguracao().urlExtratoPrestadorConsultar + filter.carteira + '/' + filter.ano + '/' + filter.mes;
      const response = await this.fetch(extratoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarProcedimentoExtrato (filter) {
    try {
      const extratoUrl = Configuracao.getConfiguracao().urlExtratoProcedimentoConsultar + filter.carteira + '/' + filter.ano + '/' + filter.mes + '/' + filter.seqPrestador + '/' + filter.prestadorSelected;
      const response = await this.fetch(extratoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarDataInicioAdesao (codServidor) {
    try {
      const extratoUrl = Configuracao.getConfiguracao().urlExtratoDataInicioAdesao + codServidor;
      const response = await this.fetch(extratoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarDividaEmAberto (filter) {
    try {
      const extratoUrl = Configuracao.getConfiguracao().urlExtratoDividaEmAberto;
      const response = await this.fetch(extratoUrl, 'post', filter);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarDividaEmAbertoBeneficiario (filter) {
    try {
      const extratoUrl = Configuracao.getConfiguracao().urlExtratoDividaEmAbertoBeneficiario + filter.codServidor + '/' + filter.ano + '/' + filter.mes;
      const response = await this.fetch(extratoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarExtratoMensalidadeResumido (codServidor) {
    try {
      const extratoUrl = Configuracao.getConfiguracao().urlExtratoMensalidadeResumidoConsultar + codServidor;
      const response = await this.fetch(extratoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarBeneficiarioExtratoMensalidade (filter) {
    try {
      const extratoUrl = Configuracao.getConfiguracao().urlExtratoMensalidadeBeneficiarioConsultar + filter.codServidor + '/' + filter.ano + '/' + filter.mes;
      const response = await this.fetch(extratoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarExtratoMensalidadeCompleto ({carteira, from, to, incluirDependentes}) {
    try {
      const extratoUrl = `${Configuracao.getConfiguracao().urlExtratoMensalidadeCompletoConsultar}/${carteira}/${from}/${to}/${incluirDependentes}`;
      const response = await this.fetch(extratoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarExtratoCoparticipacaoCompleto ({carteira, from, to, incluirDependentes}) {
    try {
      const extratoUrl = `${Configuracao.getConfiguracao().urlExtratoCoparticipacaoCompletoConsultar}/${carteira}/${from}/${to}/${incluirDependentes}`;
      const response = await this.fetch(extratoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarExtratoDividaCompleto ({carteira, ano, mes, incluirDependentes}) {
    try {
      const extratoUrl = `${Configuracao.getConfiguracao().urlExtratoDividaCompletoConsultar}/${carteira}/${ano}/${mes}/${incluirDependentes}`;
      const response = await this.fetch(extratoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async isFolhaFechada () {
    try {
      const isFolhaFechadaUrl = Configuracao.getConfiguracao().isFolhaFechadaUrl;
      const response = await this.fetch(isFolhaFechadaUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async getDataUltimoFechamentoFolha () {
    try {
      const dataUltimoFechamentoFolhaURL = Configuracao.getConfiguracao().getDataUltimoFechamentoFolhaURL;
      const response = await this.fetch(dataUltimoFechamentoFolhaURL);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarDividaProcedimentoExtrato (carteira, seqDivida, ano, mes) {
    try {
      const extratoUrl = Configuracao.getConfiguracao().urlExtratoDividaEmAbertoProcedimento + seqDivida + '/' + carteira + '/' + ano + '/' + mes;
      const response = await this.fetch(extratoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}
export default ExtratoApi;
